<template>
    <q-page class="q-pa-md">
        <cross-references ref="crossReferences"></cross-references>
    </q-page>
</template>

<script>
    export { default } from './crossreferenceapplicationviewmodel-custom-screen.js'
</script>